import type { ClinicalQualityRecommendation } from '@cartwheel/components'
import { ClinicalQualityScoreChip, DataTable } from '@cartwheel/components'
import { useState } from 'react'
import { formatDate } from '../lib/date-utils'
import {
  ClinicalQualityScoreRowActions,
  type LatestScoreSummary,
} from './clinical-quality-score-row-actions'

export interface ChartNote {
  id: string
  date: string | null
  name: string | null
  note_type: string | null
  clinician_name: string | null
  clinician_id: string | null
  finished: boolean | null
  healthie_url: string | null
  latest_clinical_quality_score: LatestScoreSummary | null
  scoring_in_progress?: boolean
}

interface ChartNoteRowProps {
  chartNote: ChartNote
  clientId: string
}

export function ChartNoteRow({ chartNote, clientId }: ChartNoteRowProps) {
  const [localLatestScore, setLocalLatestScore] = useState(chartNote.latest_clinical_quality_score)
  const latestScore = localLatestScore

  return (
    <DataTable.Row>
      <DataTable.Cell className="text-sm text-charcoal whitespace-nowrap">
        {chartNote.date ? formatDate(chartNote.date) : '—'}
      </DataTable.Cell>
      <DataTable.Cell className="text-sm text-charcoal">
        {chartNote.note_type || '—'}
      </DataTable.Cell>
      <DataTable.Cell className="text-sm text-charcoal whitespace-nowrap">
        {chartNote.clinician_id && chartNote.clinician_name ? (
          <a href={`/clinicians/${chartNote.clinician_id}`} className="text-indigo hover:underline">
            {chartNote.clinician_name}
          </a>
        ) : (
          chartNote.clinician_name || '—'
        )}
      </DataTable.Cell>
      <DataTable.Cell className="text-sm whitespace-nowrap">
        <ClinicalQualityScoreChip
          percentage={latestScore?.percentage ?? null}
          recommendation={latestScore?.recommendation as ClinicalQualityRecommendation | null}
        />
      </DataTable.Cell>
      <DataTable.Cell className="whitespace-nowrap">
        {chartNote.healthie_url ? (
          <a
            href={chartNote.healthie_url}
            target="_blank"
            rel="noopener noreferrer"
            className="text-indigo hover:underline text-sm whitespace-nowrap"
          >
            View in Healthie
          </a>
        ) : null}
      </DataTable.Cell>
      <DataTable.Cell className="text-right whitespace-nowrap">
        <ClinicalQualityScoreRowActions
          chartNoteId={chartNote.id}
          clientId={clientId}
          latestScore={latestScore}
          scoringInProgress={chartNote.scoring_in_progress}
          onScoreComplete={setLocalLatestScore}
        />
      </DataTable.Cell>
    </DataTable.Row>
  )
}
